import { useState } from 'react';
import { Send } from 'lucide-react';
import type { ActivityType } from '../../types/crm';

interface ActivityFormProps {
  onSubmit: (type: ActivityType, content: string) => Promise<void>;
}

const ACTIVITY_TYPES: { value: ActivityType; label: string }[] = [
  { value: 'NOTE', label: 'Notiz' },
  { value: 'CALL', label: 'Anruf' },
  { value: 'MESSAGE', label: 'Nachricht' },
];

export function ActivityForm({ onSubmit }: ActivityFormProps) {
  const [type, setType] = useState<ActivityType>('NOTE');
  const [content, setContent] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim() || isSubmitting) return;

    setIsSubmitting(true);
    try {
      await onSubmit(type, content.trim());
      setContent('');
      setType('NOTE');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <div className="flex gap-2">
        {ACTIVITY_TYPES.map((t) => (
          <button
            key={t.value}
            type="button"
            onClick={() => setType(t.value)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
              type === t.value
                ? 'bg-primary/20 text-primary'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="flex gap-2">
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Aktivität hinzufügen..."
          rows={2}
          className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none text-sm"
        />
        <button
          type="submit"
          disabled={!content.trim() || isSubmitting}
          className="self-end px-4 py-2.5 bg-primary text-white rounded-xl hover:bg-primary-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Send className="w-4 h-4" />
        </button>
      </div>
    </form>
  );
}
